import { makeStyles, useMediaQuery } from "@material-ui/core"
import PropTypes from "prop-types"
import React, { useState } from "react"
import AppTopBar from "./AppTopBar"
import SideNav from "./SideNav"
import SideNavTrigger from "./SideNavTrigger"

const useStyles = makeStyles(theme => ({
  root: {
    background: "#ffffff",
    display: "flex",
    height: "100%",
    width: "100%",
  },
  wrapper: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
    marginTop: 64,
    paddingTop: 16,
    [theme.breakpoints.up("md")]: {
      marginLeft: 256,
    },
  },
  contentContainer: {
    display: "flex",
    flex: "1 1 auto",
    overflow: "hidden",
  },
  content: {
    flex: "1 1 auto",
    height: "100%",
    overflow: "auto",
    padding: theme.spacing(0, 2, 2, 2),
  },
}))

const AppShell = ({ brand, end, children }) => {
  const classes = useStyles()
  const [navOpen, setNavOpen] = useState(false)
  const isDesktop = useMediaQuery(theme => theme.breakpoints.up("md"))

  return (
    <div className={classes.root}>
      <AppTopBar
        start={<SideNavTrigger onOpen={() => setNavOpen(true)} />}
        brand={brand}
        end={end}
      />
      <SideNav
        isDesktop={isDesktop}
        open={isDesktop || navOpen}
        onClose={() => setNavOpen(false)}
      />
      <div className={classes.wrapper}>
        <div className={classes.contentContainer}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  )
}

AppShell.propTypes = {
  brand: PropTypes.node,
  children: PropTypes.node,
  end: PropTypes.node,
}

AppShell.defaultProps = {
  brand: null,
  children: null,
  end: null,
}

export default AppShell
